export const PAGE_PATH_BY_NAME = {
  portal: '/',
  search: '/search',
  searchQuery: '/search/:query?',
  setting: '/setting',
  sitemap: '/sitemap',
  commonsetting: '/commonsetting',
  commonsettingAnnouncement: '/commonsetting/announcement',
  commonsettingUserManagement: '/commonsetting/usermanagement',
  commonsettingWebApi: '/commonsetting/webapi',
  commonsettingGeneral: '/commonsetting/general',
  commonsettingRole: '/commonsetting/roles',
  announcementWithId: '/announcement/:id',
  announcementList: '/announcementList',
  maintenance: '/maintenance',
  eventCalendar: '/eventCalendar/:period?/:year?/:month?/:day?',
  eventCalendarForMonth: '/eventCalendar/month',
  eventList: '/eventList',
  createEvent: '/events/create/:id?',
  editEvent: '/events/edit/:id',
  copyEvent: '/events/copy/:id',
  viewEvent: '/events/view/:id',
  jobs: '/jobs',
  createJob: '/jobs/create/:id',
  job: '/jobs/:id',
  createHoliday: '/holidays/create/:id?',
  editHoliday: '/holidays/edit/:id',
  copyHoliday: '/holidays/copy/:id',
  viewHoliday: '/holidays/view/:id',
  notFound: '/notfound',
  OSSLicense: '/osslicense',
};

export const UNDEFINED_PATH_NAME = 'unDefined';

export const CWS_ROOT_MENU_ID = 'CWS#root.cws';
export const REL =
  'noreferrer,scrollbars=1,menubar=1,toolbar=1,status=1,resizable=1,directories=1,location=1';
export const LANDSCAPE_PRODUCTION = 'production';
export const JST_OFFSET_MINS = -540;

export enum Language {
  ja = 'ja',
  en = 'en',
}

export const ICON = {
  NOT_TRIGGERED: {
    COLOR: '#808080',
    NAME: 'mdi-checkbox-blank-circle-outline',
  },
  RUNNING: {
    COLOR: '#007cc5',
    NAME: 'mdi-spin mdi-loading',
  },
  ABORTED: {
    COLOR: '#ffa500',
    NAME: 'mdi-cancel',
  },
  FAILED: {
    COLOR: '#e31e5f',
    NAME: 'mdi-close-circle',
  },
  SUCCEEDED: {
    COLOR: '#00b19d',
    NAME: 'mdi-check-circle',
  },
  SKIPPED: {
    COLOR: '#bcbcbc',
    NAME: 'mdi-skip-next-circle',
  },
  HOLIDAY: {
    COLOR: '#d9d900',
    NAME: 'mdi-checkbox-blank',
  },
  CALENDAR: {
    COLOR: '#d9d900',
    NAME: 'mdi-calendar',
  },
  PUBLIC_HOLIDAY: {
    COLOR: '#5fc633',
    NAME: 'mdi-checkbox-blank',
  },
  CUSTOM_HOLIDAY: {
    COLOR: '#d9d900',
    NAME: 'mdi-checkbox-blank',
  },
};

export enum Day {
  Sunday,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
}

export const SNACKBAR_TIMEOUT = 5000;

export const PUBLIC_HOLIDAY = 'PUBLIC HOLIDAY/祝日';

export const INFINITE_DATE = '3000-01-01';

export enum TriggerOnHolidays {
  allHolidays,
  customHolidays,
}

export enum PageType {
  create = '/create',
  edit = '/edit',
  copy = '/copy',
  view = '/view',
}

export enum UserAction {
  Create,
  Edit,
  Abort,
  Cancel,
}

export enum AvailableActions {
  Abort,
}

export enum TZIDLocations { //TODO: Add support for other timezone
  UTC9 = 'Asia/Tokyo',
}

export enum DisplayPeriod {
  month = 'month',
  //TODO:Remove comment out When we add other display styles
  // week = 'week',
  // day = 'day',
  // year = 'year',
}

export enum DialogType {
  Info,
  Warning,
}

export enum ApplicationDomain {
  localhost = 'localhost',
  portalCommercial = 'portal.company.works-hi.com',
  portalIntra = 'portal.lab.works-hi.com',
  fbsCommercial = 'fbs.company.works-hi.co.jp',
  fbsIntra = 'fbs.company.lab.works-hi.co.jp',
}

export enum StepFunctionStatus {
  RUNNING = 'RUNNING',
  SUCCEEDED = 'SUCCEEDED',
  FAILED = 'FAILED',
  TIMED_OUT = 'TIMED_OUT',
  ABORTED = 'ABORTED',
}

export enum ImportJobStatus {
  notStarted = 'notStarted',
  started = 'started',
  completed = 'completed',
  error422 = 'error422',
  error500 = 'error500',
}

const USER_MANUAL_URL_BASE_INTRA = 'https://user-devmanual.';

const USER_MANUAL_URL_BASE_COMMERCIAL = 'https://user-manual.';

export const LOCALHOST_8088 = 'http://localhost:8088';

export const PORTAL_USER_MANUAL_URL_INTRA = `${USER_MANUAL_URL_BASE_INTRA}${ApplicationDomain.portalIntra}`;

export const PORTAL_USER_MANUAL_URL_COMMERCIAL = `${USER_MANUAL_URL_BASE_COMMERCIAL}${ApplicationDomain.portalCommercial}`;

export const FBS_USER_MANUAL_URL_INTRA = `${USER_MANUAL_URL_BASE_INTRA}${ApplicationDomain.fbsIntra}`;

export const FBS_USER_MANUAL_URL_COMMERCIAL = `${USER_MANUAL_URL_BASE_COMMERCIAL}${ApplicationDomain.fbsCommercial}`;
